











import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { SmartAutocompletion } from '~/models/search-bar'
import { ciSparkles } from '~/icons/source/regular/sparkles'
export default defineComponent({
  props: {
    action: {
      type: Object as PropType<SmartAutocompletion>,
      required: true
    }
  },
  setup() {
    return {
      ciSparkles
    }
  }
})
